import ImportCustomersContainer from './ImportCustomers';
// import './importProducts.scss';

export default {
  title: 'Import Customers',
  description: 'Upload csv file to import customer data into Erply.',
  path: '/setup/import-customers',
  component: ImportCustomersContainer,
  rootPath: { name: 'General Setup', uri: '/setup' },
  subPath: [{ name: 'Import Customers' }],
};
